import { createRequestHook as baseCreateRequestHook, Request, RequestHook } from "@shared/platform-api/requests"
import { unwrap } from "@shared/utils/helpers/unwrap"
import { useAuth } from "../contexts/AuthProvider"

export const createRequestHook = <I, O, SK = []>(request: Request<I, O>): RequestHook<I, O, SK> =>
  baseCreateRequestHook(request, () => {
    const auth = useAuth()
    return async () => unwrap(await auth.getToken())
  })
